import type { JobRunsPeriod, JobRunsQuery, JobRunsStatusFilter, JobRunTrigger } from "../types/job";

/**
 * O filtro do histórico no endereço da página (AB#87442): quem copia o link vê o
 * mesmo recorte. A busca fica de fora — ela muda a cada tecla, e o endereço
 * mudaria junto.
 */

export const DEFAULT_RUNS_QUERY: JobRunsQuery = { status: "all", period: "7d", trigger: "all", jobIds: [], q: "" };

const STATUSES: readonly JobRunsStatusFilter[] = ["all", "running", "completed", "failed"];
const PERIODS: readonly JobRunsPeriod[] = ["24h", "7d", "30d", "all"];
const TRIGGERS: readonly ("all" | JobRunTrigger)[] = ["all", "schedule", "webhook", "manual"];

function pick<T extends string>(value: string | null, allowed: readonly T[], fallback: T): T {
  return value !== null && (allowed as readonly string[]).includes(value) ? (value as T) : fallback;
}

/** O filtro lido do endereço; o que não é reconhecido cai no padrão. */
export function runsQueryFromParams(params: URLSearchParams): JobRunsQuery {
  const jobIds = (params.get("job") ?? "")
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean);
  return {
    status: pick(params.get("status"), STATUSES, DEFAULT_RUNS_QUERY.status),
    period: pick(params.get("period"), PERIODS, DEFAULT_RUNS_QUERY.period),
    trigger: pick(params.get("trigger"), TRIGGERS, DEFAULT_RUNS_QUERY.trigger),
    jobIds,
    q: "",
  };
}

/** Os parâmetros do histórico com este filtro — só o que difere do padrão, para o link ficar curto. */
export function runsParamsOf(query: JobRunsQuery): URLSearchParams {
  const params = new URLSearchParams({ tab: "runs" });
  if (query.jobIds.length > 0) params.set("job", query.jobIds.join(","));
  if (query.period !== DEFAULT_RUNS_QUERY.period) params.set("period", query.period);
  if (query.status !== DEFAULT_RUNS_QUERY.status) params.set("status", query.status);
  if (query.trigger !== DEFAULT_RUNS_QUERY.trigger) params.set("trigger", query.trigger);
  return params;
}

/**
 * O histórico de um job, aberto da lista: em todo o período — um job semanal
 * que rodou há oito dias apareceria vazio na janela padrão de 7 dias.
 */
export function jobHistoryParams(jobId: string): URLSearchParams {
  return runsParamsOf({ ...DEFAULT_RUNS_QUERY, jobIds: [jobId], period: "all" });
}
